import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "px-8 mt-3" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "No"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-1250px; text-left" }, "Nama Fitur"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Release"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-left" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = {
  class: "mx-auto",
  style: {"width":"fit-content"}
}
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-square text-white" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Edit", -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "row mt-5 mb-5" }
const _hoisted_24 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_25 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_26 = ["label", "value"]
const _hoisted_27 = { class: "p-3" }
const _hoisted_28 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "btn btn-primary mb-4",
          style: {"font-weight":"400","margin-top":"0px"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/superadmin/master-feature/add')))
        }, " Tambah Fitur "),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control w-250px ps-15",
            placeholder: "Cari Nama Fitur",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
            onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.eventDelaySearch()))
          }, null, 544), [
            [_vModelText, _ctx.name]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _hoisted_8,
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_10, _toDisplayString(index + 1), 1),
                      _createElementVNode("td", _hoisted_11, _toDisplayString(item.feature_name), 1),
                      _createElementVNode("td", _hoisted_12, _toDisplayString(item.feature_status), 1),
                      _createElementVNode("td", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_Switch, {
                            modelValue: item.isActive,
                            "onUpdate:modelValue": ($event: any) => ((item.isActive) = $event),
                            "is-active": item.isActive,
                            "model-key": index,
                            "non-active-value": "Non Active",
                            "active-value": "Active"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "is-active", "model-key"])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_15, [
                        _createElementVNode("a", {
                          class: "symbol symbol-30px me-2 p-2 px-3 text-white bg-warning fw-bold",
                          "data-bs-toggle": "tooltip",
                          title: "Edit",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (
                      _ctx.$router.push(
                        '/superadmin/master-feature/edit/' + item._id
                      )
                    )
                        }, _hoisted_19, 8, _hoisted_16)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_20, _hoisted_22))
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_26))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_Pagination, {
              paging: _ctx.paging,
              onNext: _ctx.nextPage,
              onPrev: _ctx.prevPage,
              "max-visible-pages": 5
            }, null, 8, ["paging", "onNext", "onPrev"])
          ])
        ])
      ])
    ], 2)
  ], 64))
}